import { useEffect } from 'react';

export const useClickOutside = (ref, callback) => {
	useEffect(() => {
		const element = ref.current;
		if (!element) return null;

		const handleClickOutside = (event) => {
			if (!element.contains(event.target)) {
				callback();
			}
		};

		const handleFocusOut = (event) => {
			// iOS WebKit sets relatedTarget to null on touch;
			const focusMovedTo = event.relatedTarget || document.activeElement;
			if (!element.contains(focusMovedTo)) {
				callback();
			}
		};

		document.addEventListener('mousedown', handleClickOutside);
		element.addEventListener('focusout', handleFocusOut);

		return () => {
			document.removeEventListener('mousedown', handleClickOutside);
			element.removeEventListener('focusout', handleFocusOut);
		};
	}, [ref, callback]);
};
